import { getUser } from '@/utils/user';

/**
 * Redirect user based on authentication information.
 * If unauthenticated, we will display the referer page if exist.
 *
 * @todo add debug log for redirection
 *
 * Examples:
 *
 *   // redirect to search if authenticated
 *   redirect({
 *     name: 'MyPage
 *   }, '/search')
 *
 * @param {Object} component
 * @param {String | Function} destination
 * @param {Boolean} isUnauthenticated
 * @return {Object}
 * @public
 */
const redirect = (component, destination = '/', isUnauthenticated) => {
  const {
    beforeRouteEnter = (to, from, next) => next(),
  } = component;
  return {
    ...component,
    async beforeRouteEnter(to, from, next) {
      const user = await getUser();
      const { name } = from;
      const bool = user.isAuthenticated === !isUnauthenticated;
      // @todo do emailVerified bool && user.emailVerified
      if (bool) {
        if (isUnauthenticated && name) next((vm) => vm.$router.push(name));
        else next((vm) => vm.$router.push(functionify(destination)(user, to.query.referrer)));
      } else {
        await beforeRouteEnter(to, from, next);
      }
    },
  };
};

/**
 * Create a function from an argument whatever its type.
 *
 * @returns {Function}
 * @private
 */

function functionify(src) {
  if (typeof src === 'function') return src;
  return () => src;
}

export default redirect;
